<section class="roles-permisions-feature">
    <img src="/icons/lock.svg" alt="">
    <h2>NO TIENES ACCESO A ESTE MODULO</h2>
</section>

